<template>
  <div class="row">&nbsp;</div>
  <div v-if="this.page_permission === 'Y'">
    <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <!-- <WelcomeCard /> -->
          <div class="col-xxl-12">
            <div class="row widget-grid">
              
                <div class="card profile-box">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0"><vue-feather type="bar-chart" size="36"></vue-feather>  ADJUSTMENT (PARTNER)</h4>
                          <p>&nbsp;</p>
                          <!-- <p>{{ this.eventDetails.event_date }},{{ this.eventDetails.province }}</p> -->

                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
             
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>ข้อมูลกิจกรรม (PARTNER) <a :href="'/order-admin/'+this.$route.params.q" >[รายงาน]</a>  </b></h5>
              
              
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <tbody >
                <tr>
                  <td>ชื่อกิจกรรม</td>
                  <td><input type="text" class="form-control" id="txt_title" v-model="txt_title" ></td>
                  <td>สถานที่จัดกิจกรรม</td>
                  <td><input type="text" class="form-control" id="txt_province" v-model="txt_province" ></td>
                </tr>
                <tr>
                  <td>วันที่จัดกิจกรรม</td>
                  <td><input type="text" class="form-control" id="txt_title" v-model="txt_event_date" ></td>
                  <td>สถานะ</td>
                  <td><select class="form-select" v-model="txt_event_status" >
                        <option value="0" >สถานะ</option>
                        <option value="ON_SALE" >เปิดจำหน่าย</option>
                        <option value="SOON" >กิจกรรมที่กำลังจะมาถึง</option>
                        <option value="HIDE" >ซ่อนกิจกรรม</option>
                        <option value="END" >ปิดการขาย</option>
                      </select></td>
                </tr>
                <tr>
                  <td>วันที่เปิดจำหน่าย</td>
                  <td><input type="text" class="form-control" id="txt_title" v-model="txt_on_sale_start" ></td>
                  <td>วันที่ปิดจำหน่าย</td>
                  <td><input type="text" class="form-control" id="txt_title" v-model="txt_on_sale_end" ></td>
                </tr>
                <tr>
                  <td>Google Drive url</td>
                  <td><input type="text" class="form-control" id="txt_google_drive" v-model="txt_google_drive" ></td>
                  <td>Line Group url</td>
                  <td><input type="text" class="form-control" id="txt_line_group" v-model="txt_line_group" ></td>
                </tr>
                <tr>
                  <td>จำนวนช่างภาพ</td>
                  <td><input type="number" class="form-control" id="txt_number_of_photographer" v-model="txt_number_of_photographer" ></td>
                  <td>เปิดให้ช่างภาพดูรายงาน</td>
                  <td>
                    <select class="form-select" v-model="txt_is_photographer_view_report" >
                        <option value="N" >ปิด</option>
                        <option value="Y" >เปิด</option>
                      </select>
                  </td>
                </tr>
                <tr>
                  <td>ข้อความประชาสัมพันธ์</td>
                  <td colspan="3">
                    <textarea v-model="txt_post_caption" rows="10"></textarea>
                  </td>
                  
                </tr>
                <tr>
                  <td>อัปโหลด</td>
                  <td>
                    <select class="form-select" v-model="txt_uploadable" >
                        <option value="N" >ปิดให้อัปโหลด</option>
                        <option value="Y" >เปิดให้อัปโหลด</option>
                      </select>
                  </td>
                  <td>รูปแบบกิจกรรม</td>
                  <td>
                    <select class="form-select" v-model="txt_is_lock_user" >
                        <option value="N" >Open เปิดรับลงทะเบียน</option>
                        <option value="Y" >Lock User กำหนดโดยหัวหัวหน้าทีม</option>
                      </select>
                  </td>
                </tr>
                  <!-- <td>รูปแบบกิจกรรม</td>
                  <td>
                    <select class="form-select" v-model="txt_is_lock_user" >
                        <option value="N" >Open</option>
                        <option value="Y" >Lock User</option>
                      </select>
                  </td> -->
                  
               <!-- </tr>
                 <tr>
                  <td>รูปแบบการขาย</td>
                  <td>
                    <select class="form-select" v-model="txt_is_mhao" >
                        <option value="N" >กิจกรรมขายแยก</option>
                        <option value="Y" >กิจกรรมขายเหมา</option>
                      </select>
                  </td>
                  <td>ราคาเหมา</td>
                  <td>
                    <input type="number" class="form-control" id="txt_expenses" v-model="txt_mhao_price" >
                  </td>
                </tr> 
                <tr>
                  <td>ข้อความเหมา</td>
                  <td>
                    <input type="text" class="form-control" id="txt_expenses" v-model="txt_caption_button_buy_all" >
                  </td>
                  <td>ค่าใช้จ่าย</td>
                  <td>
                    <input type="number" class="form-control" id="txt_expenses" v-model="txt_expenses" >
                  </td>
                </tr>-->
                <tr>
                  <td>รูปแบบการเรียงภาพ</td>
                  <td>
                    {{ sort_by }}
                  </td>
                  
                  <td>ใส่กรอบให้ฟรี (รูปแจกฟรี)</td>
                  <td>
                    <select class="form-select" v-model="is_add_watermark_for_free_download" >
                        <option value="N" ><span style="color: red;">ไม่</span> ใส่กรอบรูปต้นฉบับให้(โหลดฟรี)</option>
                        <option value="Y" >(ใส่)กรอบรูปต้นฉบับให้(โหลดฟรี)</option>
                      </select>
                  </td>
                </tr>
                <tr>
                  <td>ราคาจำหน่าย</td>
                  <td colspan="3">
                    <p v-if="this.package.length==0"  style="color: red;">รอเพิ่มข้อมูล</p>
                      <span
                        v-for="(_package, index) in this.package"
                        :key="index"
                        class="btn btn-sm package-primary-soft"
                        ><b>{{ _package.name }}</b>
                      </span>
                  </td>
                </tr>
                <tr>
                  <td>ราคาจำหน่าย เหมาไฮบริด (ถ้ามี)</td>
                  <td colspan="2">
                    <p v-if="this.packagehb.length==0"  style="color: red;">ไม่พบข้อมูล</p>
                      <span
                        v-for="(_package, index) in this.packagehb"
                        :key="index"
                        class="btn package-primary-soft"
                        ><b>{{ _package.name }}</b>
                      </span>
                  </td>
                  <td>is_hybrid:{{this.is_hybrid}}| hybrid_mhao_price:{{this.hybrid_mhao_price}}</td>
                </tr>
                <tr v-if="parseInt(this.user.user_id) === admin_user_id_apisitchu">
                  <td>Note</td>
                  <td colspan="3">
                    <textarea disabled v-model="txt_remarks" rows="5"></textarea>
                  </td>
                  
                </tr>            
                
                <tr style="height: 170px;">
                  <td>ลายน้ำแนวนอน<br>
                    <button class="btn btn-primary btn-sm p-1"   style="vertical-align: middle;" @click.prevent="initialWatermark()">
                      <vue-feather type="corner-down-right" size="13"></vue-feather> Initial
                    </button><br><br>
                    <button class="btn btn-primary btn-sm p-1"   style="vertical-align: middle;" @click.prevent="initialWatermarkFrame()">
                      <vue-feather type="corner-down-right" size="13"></vue-feather> Initial+frame
                    </button>
                  </td>
                  <td style="background-color: rgb(155, 155, 155);">
                    <img  :src="`${this.txt_wtm_hori}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'wtm_hori')"  >
                    <div v-if="imgSizes.wtm_hori" :style="{color: imgSizeMatch('wtm_hori',720,480)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.wtm_hori.w }}x{{ imgSizes.wtm_hori.h }}px {{ imgSizeMatch('wtm_hori',720,480)?'✔ ตรงตามกำหนด':'✘ ต้องเป็น 720x480px' }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_wtm_hori" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input   required type="file" accept="image/png,image/jpeg" class="form-control-file" id="file_wtm_hori" ><br>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" id="rename_wtm_hori_none" value="" v-model="rename_wtm_hori_to">
                          <label class="form-check-label" for="rename_wtm_hori_none">ไม่เปลี่ยนชื่อไฟล์</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" id="rename_wtm_hori_cover" value="cover.jpg" v-model="rename_wtm_hori_to">
                          <label class="form-check-label" for="rename_wtm_hori_cover">เปลี่ยนชื่อเป็น cover.jpg (อัปโหลดชื่อไฟล์ใดก็ได้)</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" id="rename_wtm_hori_coupon" value="cover_coupon.jpg" v-model="rename_wtm_hori_to">
                          <label class="form-check-label" for="rename_wtm_hori_coupon">เปลี่ยนชื่อเป็น cover_coupon.jpg (อัปโหลดชื่อไฟล์ใดก็ได้)</label>
                        </div>
                        <label v-if="!rename_wtm_hori_to" for="file_wtm_hori">ภาพปกงาน (ขนาด 720X480px) และชื่อ wtm_hori.png, cover.jpg หรือ cover_coupon.jpg เท่านั้น <a :href="this.wtm_horizontal_url" target="_blank"><u>ตัวอย่าง</u></a></label>
                        <label v-else for="file_wtm_hori">ภาพปกงาน (ขนาด 720X480px) ระบบจะเปลี่ยนชื่อไฟล์เป็น {{ rename_wtm_hori_to }} ให้อัตโนมัติ <a :href="this.wtm_horizontal_url" target="_blank"><u>ตัวอย่าง</u></a></label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>
                <tr style="height: 170px;">
                  <td>ลายน้ำแนวตั้ง</td>
                  <td style="background-color: rgb(155, 155, 155);">
                    <img  :src="`${this.txt_wtm_verti}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'wtm_verti')"  >
                    <div v-if="imgSizes.wtm_verti" :style="{color: imgSizeMatch('wtm_verti',480,720)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.wtm_verti.w }}x{{ imgSizes.wtm_verti.h }}px {{ imgSizeMatch('wtm_verti',480,720)?'✔ ตรงตามกำหนด':'✘ ต้องเป็น 480x720px' }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_wtm_verti" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input  required type="file" accept="image/png" class="form-control-file" id="file_wtm_verti" ><br>
                        <label for="file_wtm_verti" id="file_wtm_verti" >ภาพปกงาน (ขนาด 480X720px)และชื่อ wtm_verti.png เท่านั้น  <a :href="this.wtm_vertical_url" target="_blank"><u>ตัวอย่าง</u></a></label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>

                <tr style="height: 170px;" >
                  <td>กรอบงานเพื่อขาย แนวนอน</td>
                  <td style="background-color: rgb(155, 155, 155);">   
                    <img :src="`${this.txt_event_frame_hori}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'event_frame_hori')"  >
                    <div v-if="imgSizes.event_frame_hori" :style="{color: imgSizeMatch('event_frame_hori', is_add_watermark_for_free_download==='Y'?4295:4000, is_add_watermark_for_free_download==='Y'?2863:2666)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.event_frame_hori.w }}x{{ imgSizes.event_frame_hori.h }}px {{ imgSizeMatch('event_frame_hori', is_add_watermark_for_free_download==='Y'?4295:4000, is_add_watermark_for_free_download==='Y'?2863:2666)?'✔ ตรงตามกำหนด':(is_add_watermark_for_free_download==='Y'?'✘ ต้องเป็น 4295x2863px':'✘ ต้องเป็น 4000x2666px') }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_event_frame_wtm_hori" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input  required type="file" accept="image/png" class="form-control-file" id="file_event_frame_wtm_hori" ><br>
                        <label v-if="this.is_add_watermark_for_free_download =='Y'" for="file_event_frame_wtm_hori" id="file_event_frame_wtm_hori" >ภาพปกงาน (ขนาด <span style="color: red;">4295X2863px</span>)และชื่อ <span style="color: red;">free_</span>event_frame_hori.png เท่านั้น  <a :href="this.frame_horizontal_free_url" target="_blank"><u>ตัวอย่าง</u></a>(กรุณาโหลดตัวอย่างไปเป็นแม่แบบในการทำกรอบ)</label>
                        <label v-if="this.is_add_watermark_for_free_download =='N'" for="file_event_frame_wtm_hori" id="file_event_frame_wtm_hori" >ภาพปกงาน (ขนาด 4000X2666px)และชื่อ event_frame_hori.png เท่านั้น  <a :href="this.frame_horizontal_url" target="_blank"><u>ตัวอย่าง</u></a>(กรุณาโหลดตัวอย่างไปเป็นแม่แบบในการทำกรอบ)</label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>
                <tr style="height: 170px;" >
                  <td>กรอบงานเพื่อขาย แนวตั้ง</td>
                  <td style="background-color: rgb(155, 155, 155);">
                    <img  :src="`${this.txt_event_frame_verti}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'event_frame_verti')"  >
                    <div v-if="imgSizes.event_frame_verti" :style="{color: imgSizeMatch('event_frame_verti', is_add_watermark_for_free_download==='Y'?2863:2666, is_add_watermark_for_free_download==='Y'?4295:4000)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.event_frame_verti.w }}x{{ imgSizes.event_frame_verti.h }}px {{ imgSizeMatch('event_frame_verti', is_add_watermark_for_free_download==='Y'?2863:2666, is_add_watermark_for_free_download==='Y'?4295:4000)?'✔ ตรงตามกำหนด':(is_add_watermark_for_free_download==='Y'?'✘ ต้องเป็น 2863x4295px':'✘ ต้องเป็น 2666x4000px') }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_event_frame_wtm_verti" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input  required type="file" accept="image/png" class="form-control-file" id="file_event_frame_wtm_verti" ><br>
                        <label v-if="this.is_add_watermark_for_free_download =='Y'" for="file_event_frame_wtm_verti" id="file_event_frame_wtm_verti" >ภาพปกงาน (ขนาด <span style="color: red;">2863X4295px</span>)และชื่อ <span style="color: red;">free_</span>event_frame_verti.png เท่านั้น  <a :href="this.frame_vertical_free_url" target="_blank"><u>ตัวอย่าง </u></a>(กรุณาโหลดตัวอย่างไปเป็นแม่แบบในการทำกรอบ)</label>
                        <label v-if="this.is_add_watermark_for_free_download =='N'" for="file_event_frame_wtm_verti" id="file_event_frame_wtm_verti" >ภาพปกงาน (ขนาด 2666X4000px)และชื่อ event_frame_verti.png เท่านั้น  <a :href="this.frame_vertical_url" target="_blank"><u>ตัวอย่าง </u></a>(กรุณาโหลดตัวอย่างไปเป็นแม่แบบในการทำกรอบ)</label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>

                <tr v-if="this.is_enable_vdo === 'Y'" style="height: 170px;">
                  <td>ลายน้ำวีดีโอแนวนอน<br> 
                    <button class="btn btn-primary btn-sm p-1"   style="vertical-align: middle;" @click.prevent="initialWatermarkVideo()">
                      <vue-feather type="corner-down-right" size="13"></vue-feather> Initial video
                    </button><br><br>
                    
                  </td>
                  <td style="background-color: rgb(155, 155, 155);">
                    <img  :src="`${this.txt_wtm_hori.replace('wtm_hori.png','video_wtm_hori.png')}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'video_wtm_hori')"  >
                    <div v-if="imgSizes.video_wtm_hori" :style="{color: imgSizeMatch('video_wtm_hori',720,405)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.video_wtm_hori.w }}x{{ imgSizes.video_wtm_hori.h }}px {{ imgSizeMatch('video_wtm_hori',720,405)?'✔ ตรงตามกำหนด':'✘ ต้องเป็น 720x405px' }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_video_wtm_hori" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input   required type="file" accept="image/png" class="form-control-file" id="file_video_wtm_hori" ><br>
                        <label for="file_video_wtm_hori" id="file_video_wtm_hori" >ภาพปกงาน (ขนาด 720X405px)และชื่อ video_wtm_hori.png เท่านั้น  <a :href="this.video_wtm_hori_url" target="_blank"><u>ตัวอย่าง</u></a></label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>
                <tr v-if="this.is_enable_vdo === 'Y'" style="height: 170px;">
                  <td>ลายน้ำวีดีโอแนวตั้ง<br> </td>
                  <td style="background-color: rgb(155, 155, 155);">
                    <img  :src="`${this.txt_wtm_verti.replace('wtm_verti.png','video_wtm_verti.png')}?t=${cacheBust}`" style="height: 130px;border: 5px solid #000000;" @load="onImgLoad($event,'video_wtm_verti')"  >
                    <div v-if="imgSizes.video_wtm_verti" :style="{color: imgSizeMatch('video_wtm_verti',405,720)?'green':'red', fontSize:'small'}">
                      ขนาดจริง {{ imgSizes.video_wtm_verti.w }}x{{ imgSizes.video_wtm_verti.h }}px {{ imgSizeMatch('video_wtm_verti',405,720)?'✔ ตรงตามกำหนด':'✘ ต้องเป็น 405x720px' }}
                    </div>
                  </td>
                  <td colspan="2">
                    <form @submit.prevent="upload_video_wtm_verti" class="needs-validation">
                      <div class="mb-3 col-sm-12">
                        <input   required type="file" accept="image/png" class="form-control-file" id="file_video_wtm_verti" ><br>
                        <label for="file_video_wtm_verti" id="file_video_wtm_verti" >ภาพปกงาน (ขนาด 405X720px)และชื่อ video_wtm_verti.png เท่านั้น  <a :href="this.video_wtm_verti_url" target="_blank"><u>ตัวอย่าง</u></a></label>
                        &nbsp;&nbsp;&nbsp;<button   type="submit"  class="btn btn-primary" ><vue-feather type="upload" size="18"> </vue-feather>อัปโหลด</button>
                      </div>
                    </form>
                  </td>
                </tr>




                <tr>
                  <td colspan="4" style="text-align: center;">
                    <button 
                    type="button"
                    @click.prevent="eventUpdate()"
                    class="btn btn-primary"
                  >
                    <vue-feather type="save"  size="18"> </vue-feather>
                    บันทึกข้อมูล
                  </button>&nbsp;
                  <button  type="button" @click.prevent="events()" class="btn btn-primary" >
                <vue-feather type="refresh-cw" size="18"> </vue-feather> รีเซ็ต
              </button>
                  </td>
                
                </tr>
                
              </tbody>
            </table>
            
          </div>
        </div>
      </div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="header-top">

              <h5 class="m-0"><b>ค้นหาช่างภาพเพื่อเพิ่มเข้าร่วมกิจกรรม</b></h5>
              <div class="m-0"></div>
              <div class="m-0"><form class="form-inline">
                <div class="form-group mb-2">
                  รหัสช่างภาพ(ตัวเลข 4 ตัว)
                </div>
                <div class="form-group mx-sm-3 mb-2">
                  <input type="text" class="form-control" id="txt_photo_search_mapping" v-model="txt_photo_search_mapping" placeholder="ป้อนรหัสช่างภาพ 4 ตัว เพื่อค้นหา">
                </div>
                <button
                type="submit"
                @click.prevent="photoSearchMapping()"
                @submit.prevent="photoSearchMapping()"
                class="btn btn-primary"
              >
                <vue-feather type="search" size="20"> </vue-feather> ค้นหา 
              </button>
              </form>
            </div>
            </div>
          </div>
          
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                  <th style="text-align: left"><b>ชื่อ</b></th>
                  <th style="text-align: left"><b>ชื่อเพจ</b></th>
                  <th style="text-align: center"><b>เพิ่ม</b></th>
                </tr>
              </thead>
              <tbody v-if="this.loadding_photo_search_mapping === 'Y'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">
                      <img
                        style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_photo_search_mapping.length === 0 && this.loadding_photo_search_mapping === 'N'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">ไม่พบข้อมูล หรืออาจจะเพิ่มข้อมูลช่างภาพท่านนี้เรียบร้อยแล้ว</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_photo_search_mapping.length !== 0">
                <tr v-for="item in this.data_photo_search_mapping" :key="item">
                  <td scope="row" style="text-align: center">
                    {{ item.user_id_text }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.name }} {{ item.sername }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.display_name }}
                  </td>
                  <td scope="row" style="text-align: center">
                    
                    <button
                      type="submit"
                      @click.prevent="addPhotoEventMapping(item.user_id)"
                      class="btn btn-success"
                    >
                      <vue-feather type="plus-circle" size="20"> </vue-feather> เพิ่ม 
                    </button>
                
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>ช่างภาพที่เข้าร่วมกิจกรรม</b></h5>
              <button
                type="button"
                @click.prevent="photoParticipate()"
                class="btn btn-primary"
              >
                <vue-feather type="refresh-cw" size="18"> </vue-feather>
                Refresh
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="text-align: center"><b>ลำดับ</b></th>
                  <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                  <th style="text-align: left"><b>ชื่อ</b></th>
                  <th style="text-align: left"><b>ชื่อเพจ</b></th>
                  <th style="text-align: center"><b>ลบ</b></th>
                </tr>
              </thead>
              <tbody v-if="this.loadding_photo_participate === 'Y'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">
                      <img
                        style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_photo_participate.length === 0 && this.loadding_photo_participate === 'N'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">ไม่พบข้อมูล</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_photo_participate.length !== 0">
                <tr v-for=" item, index in this.data_photo_participate" :key="item">
                  <td scope="row" style="text-align: center">
                    {{ index + 1 }}
                  </td>
                  <td scope="row" style="text-align: center">
                    {{ item.user_id_text }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.name }} {{ item.sername }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.display_name }}
                  </td>
                  <td scope="row" style="text-align: center">
                    <button
                      type="submit"
                      @click.prevent="delPhotoEventMapping(item.user_id)"
                      class="btn btn-danger btn-sm"
                    >
                      <vue-feather type="minus-circle" size="15"> </vue-feather> ลบ 
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-xl-12" v-if="this.user.role_name === 'systemadmin' || this.user.role_name === 'system' || this.user.role_name === 'supper-vip' || this.user.role_name === 'administrator' ||  this.user.role_name === 'photo-admin'">
        <div class="card">
          <div class="card-header">
            <div class="header-top">

              <h5 class="m-0"><b>ค้นหาผู้ดูแลกิจกรรม</b></h5>
              <div class="m-0"></div>
              <div class="m-0"><form class="form-inline">
                <div class="form-group mb-2">
                  รหัสช่างภาพ(ตัวเลข 4 ตัว)
                </div>
                <div class="form-group mx-sm-3 mb-2">
                  <input type="text" class="form-control" id="txt_owner_search_mapping" v-model="txt_owner_search_mapping" placeholder="ป้อนรหัสช่างภาพ 4 ตัว เพื่อค้นหา">
                </div>
                <button
                type="submit"
                @click.prevent="ownerSearchMapping()"
                @submit.prevent="ownerSearchMapping()"
                class="btn btn-primary"
              >
                <vue-feather type="search" size="20"> </vue-feather> ค้นหา 
              </button>
              </form>
            </div>
            </div>
          </div>
          
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                  <th style="text-align: left"><b>ชื่อ</b></th>
                  <th style="text-align: left"><b>ชื่อเพจ</b></th>
                  <th style="text-align: center"><b>เพิ่ม</b></th>
                </tr>
              </thead>
              <tbody v-if="this.loadding_owner_search_mapping === 'Y'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">
                      <img
                        style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_owner_search_mapping.length === 0 && this.loadding_owner_search_mapping === 'N'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">ไม่พบข้อมูล หรืออาจจะเพิ่มข้อมูลช่างภาพท่านนี้เรียบร้อยแล้ว</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_owner_search_mapping.length !== 0">
                <tr v-for="item in this.data_owner_search_mapping" :key="item">
                  <td scope="row" style="text-align: center">
                    {{ item.user_id_text }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.name }} {{ item.sername }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.display_name }}
                  </td>
                  <td scope="row" style="text-align: center">
                    
                    <button
                      type="submit"
                      @click.prevent="addOwnerEventMapping(item.user_id)"
                      class="btn btn-success"
                    >
                      <vue-feather type="plus-circle" size="20"> </vue-feather> เพิ่ม 
                    </button>
                
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-xl-12" v-if="this.user.role_name === 'systemadmin' || this.user.role_name === 'system' || this.user.role_name === 'supper-vip' || this.user.role_name === 'administrator' || this.user.role_name === 'photo-admin'">
        <div class="card">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>ผู้ดูแลกิจกรรม</b></h5>
              <button
                type="button"
                @click.prevent="eventOwner()"
                class="btn btn-primary"
              >
                <vue-feather type="refresh-cw" size="18"> </vue-feather>
                Refresh
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="text-align: center"><b>ลำดับ</b></th>
                  <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                  <th style="text-align: left"><b>ชื่อ</b></th>
                  <th style="text-align: left"><b>ชื่อเพจ</b></th>
                  <th style="text-align: center"><b>ลบ</b></th>
                </tr>
              </thead>
              <tbody v-if="this.loadding_event_owner === 'Y'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">
                      <img
                        style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_event_owner.length === 0 && this.loadding_event_owner === 'N'">
                <tr>
                  <td colspan="6">
                    <div class="d-flex justify-content-center">ไม่พบข้อมูล</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="this.data_event_owner.length !== 0">
                <tr v-for=" item, index in this.data_event_owner.filter(f => f.role_name !== 'photo-admin')" :key="item">
                  <td scope="row" style="text-align: center">
                    {{ index + 1 }}
                  </td>
                  <td scope="row" style="text-align: center">
                    {{ item.user_id_text }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.name }} {{ item.sername }}
                  </td>
                  <td scope="row" style="text-align: left">
                    {{ item.display_name }}
                  </td>
                  <td scope="row" style="text-align: center">
                    <button
                      type="submit"
                      @click.prevent="delOwnerEventMapping(item.user_id)"
                      class="btn btn-danger btn-sm"
                    >
                      <vue-feather type="minus-circle" size="15"> </vue-feather> ลบ 
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div v-if="this.page_permission === 'N'">
    <div class="d-flex justify-content-center">this page is not authorized</div>
  </div>
</template>
<style scoped>
.package-primary-soft {
  border-color: #b6d4fe;
  background-color: #eef4ff;
  color: #0d6efd;
}

.package-primary-soft:hover {
  border-color: #86b7fe;
  background-color: #dbeafe;
  color: #0a58ca;
}

.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.table-fit {
  width: 1px;
}

textarea
{
  width:100%;
}
.textwrapper
{
  border:1px solid #999999;
  margin:5px 0;
  padding:3px;
}
</style>
<script>

import axios from "axios";
export default {
  data() {
    return {
      loadding: "N",
      imgSizes: {},
      cacheBust: Date.now(),
      admin_user_id_apisitchu: parseInt(process.env.VUE_APP_ADMIN_USER_ID_APISITCHU),
      wtm_horizontal_url: process.env.VUE_APP_WTM_HORIZONTAL,
      wtm_vertical_url: process.env.VUE_APP_WTM_VERTICAL,
      frame_horizontal_url: process.env.VUE_APP_FRAME_HORIZONTAL,
      frame_vertical_url: process.env.VUE_APP_FRAME_VERTICAL,
      frame_horizontal_free_url: process.env.VUE_APP_FRAME_HORIZONTAL_FREE,
      frame_vertical_free_url: process.env.VUE_APP_FRAME_VERTICAL_FREE,
      video_wtm_hori_url: process.env.VUE_APP_VIDEO_WTM_HORIZONTAL,
      video_wtm_verti_url: process.env.VUE_APP_VIDEO_WTM_VERTICAL,
      event: {},
      package: {},
      packagehb: {},
      txt_title: "",
      txt_province: "",
      txt_event_date: "",
      txt_on_sale_start: "",
      txt_on_sale_end: "",
      txt_event_status: "0",
      txt_google_drive: "",
      txt_line_group: "",
      txt_number_of_photographer: 0,
      txt_is_photographer_view_report: "N",
      txt_post_caption: "",
      txt_is_lock_user: "N",
      txt_is_mhao: "N",
      txt_mhao_price: 0,
      txt_caption_button_buy_all: "",
      txt_uploadable: "N",
      txt_remarks: "",
      text_wtm_hori: "",
      txt_wtm_verti: "",
      txt_event_frame_hori: "",
      txt_event_frame_verti: "",

      loadding_photo_participate: "N",
      data_photo_participate: [],

      loadding_photo_search_mapping: "N",
      data_photo_search_mapping: [],
      txt_photo_search_mapping: "",


      loadding_owner_search_mapping: "N",
      data_owner_search_mapping: [],
      txt_owner_search_mapping: "",

      loadding_event_owner: "N",
      data_event_owner: [],
     

      user: {},
      page_permission: null,
      token: localStorage.getItem("jwt"),

      colecttion: "Y",
      is_hybrid: "",
      hybrid_mhao_price: 0,

      is_add_watermark_for_free_download: "N",
      rename_wtm_hori_to: "",

      is_enable_vdo: "N",
    };
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {

    try {
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post("/v1/partner/permission", data,{
        headers
      });
      if (response.data.status === "success") {
        let bodyPermission = JSON.parse(JSON.stringify(response.data.body));
        this.page_permission = bodyPermission.permission

        this.user = JSON.parse(localStorage.getItem('user'))

      if(this.page_permission ==='Y'){
          this.photoParticipate();
          this.events();
          //this.systemTagProcess();
          //this.reportSymmery();
          //this.reportPerformance();

      }

      }else{
        alert("permission is not recognized by admin")
      }

      this.eventOwner()

      
    } catch (error) {
      alert("login พบข้อผิดพลาด กรุณาแจ้งผู้ดูแลระบบ")
      //this.$router.push({ path: "/auth/login" });
    }
  },
  methods: {
    onImgLoad(e, key){
      const w = e.target.naturalWidth, h = e.target.naturalHeight
      const s = this.imgSizes[key]
      if(!s || s.w !== w || s.h !== h){
        this.imgSizes[key] = { w, h }
      }
    },
    imgSizeMatch(key, w, h){
      const s = this.imgSizes[key]
      return s ? (s.w === w && s.h === h) : false
    },
    async upload_video_wtm_verti(){
      let data = new FormData();
      const file_video_wtm_verti = document.getElementById('file_video_wtm_verti').files[0];
      data.append('file', file_video_wtm_verti);
      data.append('event_key', this.$route.params.q);

      if(file_video_wtm_verti.name !== 'video_wtm_verti.png'){
        alert('กรุณา upload ชื่อไฟล์ video_wtm_verti.png เท่านั้น');
        return false;
      }

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            //alert("อัปโหลด ลายน้ำแนวตั้ง สำเร็จ")
            this.cacheBust = Date.now();
            this.events();
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async upload_video_wtm_hori(){
      let data = new FormData();
      const file_video_wtm_hori = document.getElementById('file_video_wtm_hori').files[0];
      data.append('file', file_video_wtm_hori);
      data.append('event_key', this.$route.params.q);

      if(file_video_wtm_hori.name !== 'video_wtm_hori.png'){
        alert('กรุณา upload ชื่อไฟล์ video_wtm_hori.png เท่านั้น');
        return false;
      }

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            this.cacheBust = Date.now();
            this.events();
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async initialWatermarkVideo() {
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/utils/initial-watermark-video",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        alert("Initial watermark success")
        this.events();
      } else {
        alert("An error has occurred. Please contact the system administrator: "+response.data.message)
      }
    },
    async initialWatermark() {
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/utils/initial-watermark",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        alert("Initial watermark success")
        this.events();
      } else {
        alert("An error has occurred. Please contact the system administrator: "+response.data.message)
      }
    },
    async initialWatermarkFrame() {
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/utils/initial-watermark-frame",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        alert("Initial watermark success")
        this.events();
      } else {
        alert("An error has occurred. Please contact the system administrator: "+response.data.message)
      }
    },
    async upload_event_frame_wtm_verti(){
      let data = new FormData();
      const file_event_frame_wtm_verti = document.getElementById('file_event_frame_wtm_verti').files[0];
      data.append('file', file_event_frame_wtm_verti);
      data.append('event_key', this.$route.params.q);

      if(file_event_frame_wtm_verti.name !== 'event_frame_verti.png' && file_event_frame_wtm_verti.name !== 'free_event_frame_verti.png' ){
        alert('กรุณา upload ชื่อไฟล์ event_frame_verti.png หรือ free_event_frame_verti.png เท่านั้น');
        return false;
      }

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            //alert("อัปโหลด กรอบงานเพื่อขาย แนวตั้ง สำเร็จ")
            this.cacheBust = Date.now();
            this.events();
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async upload_event_frame_wtm_hori(){
      let data = new FormData();
      const file_event_frame_wtm_hori = document.getElementById('file_event_frame_wtm_hori').files[0];
      data.append('file', file_event_frame_wtm_hori);
      data.append('event_key', this.$route.params.q);

      if(file_event_frame_wtm_hori.name !== 'event_frame_hori.png' && file_event_frame_wtm_hori.name !== 'free_event_frame_hori.png'){
        alert('กรุณา upload ชื่อไฟล์ event_frame_hori.png หรือ free_event_frame_hori.png เท่านั้น');
        return false;
      }

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            //alert("อัปโหลด กรอบงานเพื่อขาย แนวนอน สำเร็จ")
            this.cacheBust = Date.now();
            this.events();
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async upload_wtm_verti(){
      let data = new FormData();
      const file_wtm_verti = document.getElementById('file_wtm_verti').files[0];
      data.append('file', file_wtm_verti);
      data.append('event_key', this.$route.params.q);

      if(file_wtm_verti.name !== 'wtm_verti.png'){
        alert('กรุณา upload ชื่อไฟล์ wtm_verti.png เท่านั้น');
        return false;
      }

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            //alert("อัปโหลด ลายน้ำแนวตั้ง สำเร็จ")
            this.cacheBust = Date.now();
            this.events();
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async upload_wtm_hori(){
      let data = new FormData();
      const file_wtm_hori = document.getElementById('file_wtm_hori').files[0];

      let upload_name = file_wtm_hori.name;
      if(this.rename_wtm_hori_to){
        upload_name = this.rename_wtm_hori_to;
        data.append('file', new File([file_wtm_hori], upload_name, { type: 'image/jpeg' }));
      }else{
        if(!['wtm_hori.png', 'cover.jpg', 'cover_coupon.jpg'].includes(file_wtm_hori.name)){
          alert('กรุณา upload ชื่อไฟล์ wtm_hori.png, cover.jpg หรือ cover_coupon.jpg เท่านั้น');
          return false;
        }
        data.append('file', file_wtm_hori);
      }
      data.append('event_key', this.$route.params.q);

      const headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`
        };

        axios.post('/v1/utils/event-create-file', data, { headers })
          .then((response) => {
            this.cacheBust = Date.now();
            if(upload_name === 'cover.jpg' || upload_name === 'cover_coupon.jpg'){
              alert("อัปโหลด " + upload_name + " สำเร็จ")
            }else{
              this.events();
            }
          })
          .catch((error) => {
            alert('พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ: '+error)
          });

    },
    async events(){
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/events",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.event = response.data.body
        this.package = response.data.package
        this.packagehb = response.data.packagehb
        this.cacheBust = Date.now()
        if(this.event.length > 0){
          this.txt_title = this.event[0].title
          this.txt_province = this.event[0].province
          this.txt_event_date = this.event[0].event_date
          this.txt_on_sale_start = this.event[0].on_sale_start
          this.txt_on_sale_end = this.event[0].on_sale_end
          this.txt_event_status = this.event[0].event_status
          this.txt_google_drive = this.event[0].google_drive
          this.txt_line_group = this.event[0].line_group
          this.txt_number_of_photographer = this.event[0].number_of_photographer
          this.txt_is_photographer_view_report = this.event[0].is_photographer_view_report
          this.txt_post_caption = this.event[0].post_caption
          this.txt_is_lock_user = this.event[0].is_lock_user
          this.txt_expenses = this.event[0].expenses

          this.txt_is_mhao = this.event[0].is_mhao
          this.txt_mhao_price = this.event[0].mhao_price
          this.txt_caption_button_buy_all = this.event[0].caption_button_buy_all
          this.txt_uploadable = this.event[0].uploadable
          this.txt_remarks = this.event[0].remarks

          this.txt_wtm_hori = this.event[0].wtm_hori
          this.txt_wtm_verti = this.event[0].wtm_verti
          this.txt_event_frame_hori = this.event[0].is_add_watermark_for_free_download==='Y'? this.event[0].free_event_frame_hori:this.event[0].event_frame_hori
          this.txt_event_frame_verti = this.event[0].is_add_watermark_for_free_download==='Y'? this.event[0].free_event_frame_verti:this.event[0].event_frame_verti


          this.colecttion = this.event[0].colecttion
          this.is_hybrid = this.event[0].is_hybrid
          this.hybrid_mhao_price = this.event[0].hybrid_mhao_price

          this.sort_by = this.event[0].sort_by
          this.is_add_watermark_for_free_download = this.event[0].is_add_watermark_for_free_download

          this.is_enable_vdo = this.event[0].is_enable_vdo  

        }else{
          alert("โหลด events พบข้อผิดพลาด!");
        }
      } else {
        alert("events พบข้อผิดพลาด!");
      }
    },
    async eventUpdate(){
      if(confirm("บันทึกข้อมูล กิจกรรม?")){
          let data = {
            event_key: this.$route.params.q,
            title: this.txt_title,
            province: this.txt_province,
            event_date: this.txt_event_date,
            on_sale_start: this.txt_on_sale_start,
            on_sale_end: this.txt_on_sale_end,
            event_status: this.txt_event_status,
            google_drive: this.txt_google_drive,
            line_group: this.txt_line_group,
            number_of_photographer: this.txt_number_of_photographer,
            is_photographer_view_report: this.txt_is_photographer_view_report,
            post_caption : this.txt_post_caption,

            is_lock_user : this.txt_is_lock_user,
            expenses : this.txt_expenses,
            is_mhao : this.txt_is_mhao,
            mhao_price : this.txt_mhao_price,

            is_add_watermark_for_free_download : this.is_add_watermark_for_free_download,

            caption_button_buy_all : this.txt_caption_button_buy_all,
            uploadable : this.txt_uploadable,
            remarks: this.txt_remarks,
            is_event_manual: "-",
            is_enable_vdo: "-",
            is_enable_image_adjustment: "-",
        };
        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
        "v1/partner/events-update-admin",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        alert("บันทึกข้อมูลสำเร็จ");
        this.events();
      }else {
        alert("บันทึกข้อมูล พบข้อผิดพลาด!");
      }
      }

    },

    async photoParticipate(){
      this.loadding_photo_participate = "Y";
      this.data_photo_participate = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event-user-mapping",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_photo_participate = response.data.body;

        this.loadding_photo_participate = "N";
      } else {
        alert("photo_participate พบข้อผิดพลาด!");
      }
    },
    async photoSearchMapping(){
      if(this.txt_photo_search_mapping.length === 4){
        this.loadding_photo_search_mapping = "Y";
        this.data_photo_search_mapping = [];
        let data = {
          event_key: this.$route.params.q,
          user_id: this.txt_photo_search_mapping
        };
        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          this.data_photo_search_mapping = response.data.body;

          this.loadding_photo_search_mapping = "N";
        } else {
          alert("photo_search_mapping พบข้อผิดพลาด!");
        }
      }else{
        alert("กรุณาป้อนรหัสช่างภาพ 4 หลัก")
      }

      
    },

    async addPhotoEventMapping(_user_id){
        let data = {
          event_key: this.$route.params.q,
          user_id: _user_id,
          action: 'ADD'
        };
        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping-add",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          //alert("เพิ่มข้อมูล เรียบร้อย")
        } else {
          alert("เพิ่มข้อมูลช่างภาพ พบข้อผิดพลาด "+response.data.message);
        }
        this.data_photo_search_mapping = [];
        this.photoParticipate();

    },
    async delPhotoEventMapping(_user_id){
      if(confirm("ต้องการลบข้อมูลผู้เข้าร่วมกิจกรรม?")){
        let data = {
          event_key: this.$route.params.q,
          user_id: _user_id,
          action: 'DEL'
        };

        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping-revoke",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          //alert("ลบข้อมูล เรียบร้อย")
        } else {
          alert("ลบข้อมูลช่างภาพ พบข้อผิดพลาด "+response.data.message);
        }
        this.photoParticipate();
      }
        
    },


    async ownerSearchMapping(){
      if(this.txt_owner_search_mapping.length === 4){
        this.loadding_owner_search_mapping = "Y";
        this.data_owner_search_mapping = [];
        let data = {
          event_key: this.$route.params.q,
          user_id: this.txt_owner_search_mapping
        };

        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping-owner",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          this.data_owner_search_mapping = response.data.body;

          this.loadding_owner_search_mapping = "N";
        } else {
          alert("owner_search_mapping พบข้อผิดพลาด!");
        }
      }else{
        alert("กรุณาป้อนรหัสช่างภาพ 4 หลัก")
      }

      
    },

    async addOwnerEventMapping(_user_id){
        let data = {
          event_key: this.$route.params.q,
          user_id: _user_id,
          action: 'ADD'
        };

        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping-add-owner",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          //alert("เพิ่มข้อมูล เรียบร้อย")
        } else {
          alert("เพิ่มข้อมูลผู้ดูแล พบข้อผิดพลาด "+response.data.message);
        }
        this.data_owner_search_mapping = [];
        this.eventOwner();

    },
    async delOwnerEventMapping(_user_id){
      if(confirm("ต้องการลบข้อมูลผู้เข้าร่วมกิจกรรม?")){
        let data = {
          event_key: this.$route.params.q,
          user_id: _user_id,
          action: 'DEL'
        };

        const headers = {
         'Authorization': 'Bearer ' + this.token
      };
        const response = await axios.post(
          "v1/partner/event-search-user-mapping-revoke-owner",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          //alert("ลบข้อมูล เรียบร้อย")
        } else {
          alert("ลบข้อมูลช่างภาพ พบข้อผิดพลาด "+response.data.message);
        }
        this.eventOwner();
      }
        
    },
    async eventOwner(){
      this.loadding_event_owner = "Y";
      this.data_event_owner = [];
      let data = {
        event_key: this.$route.params.q,
      };

      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event-user-owner",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_event_owner = response.data.body;

        this.loadding_event_owner = "N";
      } else {
        alert("event_owner พบข้อผิดพลาด!");
      }
    }
  }
  
};
</script>
